import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./shared/auth/auth-guard.service";

export const appRoutes: Routes = [
    { path: "", redirectTo: "/authenticated/product-list", pathMatch: "full" },
    { path: "authenticated", canActivate: [AuthGuard], loadChildren: () => import("./+authenticated/authenticated.module").then((m) => m.AuthenticatedModule) },
    { path: "login", loadChildren: () => import("./+login/login.module").then((m) => m.LoginModule) },
    { path: "**", redirectTo: "/authenticated/product-list", pathMatch: "full" },
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);
